import { AsyncPipe, ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DeviceService, FloatingPanelService } from '@shared/services';
import { ScrollToService } from '@shared/v2';
import { IconTypes } from '@shared/v2/models';
import { WindowRef } from '@spartacus/core';
import {
  asyncScheduler,
  combineLatest,
  distinctUntilChanged,
  filter,
  fromEvent,
  map,
  Observable,
  startWith,
  throttleTime,
} from 'rxjs';
import { SdvorIconComponent } from '../icon';

const SCROLL_TO_SHOW_UP_BUTTON = 100;

@Component({
  selector: 'sd-scroll-to-top',
  imports: [SdvorIconComponent, AsyncPipe],
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorScrollToTopComponent implements OnInit {
  isMobile$: Observable<boolean> = this.deviceService.isMobileSmDown$;
  isHidden$: Observable<boolean>;
  isFloatingPanelVisible$: Observable<boolean>;

  iconArrowTop = IconTypes.ARROW_TOP;

  constructor(
    private viewportScroller: ViewportScroller,
    private floatingPanelService: FloatingPanelService,
    private windowRef: WindowRef,
    private deviceService: DeviceService,
    private scrollToService: ScrollToService,
  ) {}

  ngOnInit(): void {
    let lastScrollTop = 0;

    this.isHidden$ = combineLatest({
      scrollEvent: fromEvent(this.windowRef.nativeWindow as Window, 'scroll').pipe(
        filter(() => this.windowRef.isBrowser()),
        throttleTime(100, asyncScheduler, { trailing: true }),
        startWith(true),
      ),
      isMobile: this.isMobile$,
    }).pipe(
      map(({ isMobile }) => {
        const scrollPosition = this.viewportScroller.getScrollPosition()[1];

        if (!isMobile) {
          return scrollPosition <= SCROLL_TO_SHOW_UP_BUTTON;
        }

        const isScrollingUp = scrollPosition < lastScrollTop;
        lastScrollTop = scrollPosition;

        return !isScrollingUp || scrollPosition <= SCROLL_TO_SHOW_UP_BUTTON;
      }),
      distinctUntilChanged(),
    );

    this.isFloatingPanelVisible$ = this.floatingPanelService.getVisibility();
  }

  scrollToTop(): void {
    if (!this.windowRef.isBrowser()) {
      return;
    }

    this.scrollToService.scrollToTop();
  }
}
